<template>
  <div>
    <div class="head flex" :class="{ Mobilehaed: isMobile == 'Mobile' }">
        <router-link to="javascript:void(0);" @click="$router.go(-1)" v-if="isMobile == 'PC'" class="a-link"><img class="backimg" src="../assets/back.png" alt=""></router-link>
        <p class="flexs Mobiletxt" v-if="isMobile == 'Mobile'">{{title}}</p>
        <p v-else>{{title}}</p>
    </div>
  </div>
  
</template>

<script setup>
    const isMobile = localStorage.getItem('userAgent')
    const props = defineProps({
        title: String,   // 类型校验
    });
</script>


<style scoped>
    .head{
        position: fixed;
        width: 100%;
        height: 100px;
        background: white;
        border-top: 2px solid #f0f0f0;
        border-bottom: 2px solid #f0f0f0;
        z-index: 1;
        top: 100px;
        justify-content: flex-start;
        .backimg {
            width: 16px;
            height: 16px;
            margin: 0 60px;
        }
        p {
            text-align: left;
        }
    }
    .Mobilehaed{
        border: none;
        height: 80px;
        top: 80px;
        
        .Mobiletxt{
            margin-left: 22px;
            color: black;
            font-size: 32px;
        }
    }
</style>
